import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import { Box, Container, Divider, IconButton } from '@mui/material';
import CadsoftLogo from '../icons/CadsoftLogo';
import { Facebook, Home, Instagram, LinkedIn, YouTube } from '@mui/icons-material';

const Footer = () => {

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const footerLink = {
    color: "#282425",
    textDecoration: "none",
    "&:hover": {
      color: "#d13138",
      textDecoration: "underline",
    }
  }

  return (
    <Container sx={{mt: 5,}}>
      <Grid container spacing={2} justify="center">
        <Grid item xs={12} sm={6} md={3}>
          <Typography fontSize={16} fontWeight={600} textTransform="uppercase" sx={{mb:2,}} variant="h6">Products</Typography>
          <Box sx={{display: "flex", flexDirection: "column",}}>
            <Link href="https://www.cadsoft.com/products/trial-download/" sx={footerLink}>Trial Download</Link>
            <Link href="https://www.cadsoft.com/buy-or-upgrade/" sx={footerLink}>Buy or Upgrade</Link>
            <Link href="https://www.cadsoft.com/products/personal-architect/" sx={footerLink}>Personal Architect</Link>
            <Link href="https://www.cadsoft.com/products/pro-architect/" sx={footerLink}>Pro Architect</Link>
            <Link href="https://www.cadsoft.com/products/building-essentials/" sx={footerLink}>Building Essentials</Link>
            <Link href="https://www.cadsoft.com/products/construction-suite/" sx={footerLink}>Construction Suite</Link>
            <Link href="https://www.cadsoft.com/products/product-comparison/" sx={footerLink}>Comparison Chart</Link>
            <Link href="https://www.cadsoft.com/our-services/" sx={footerLink}>Design Service Center</Link>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography fontSize={16} fontWeight={600} textTransform="uppercase" sx={{mb:2,}}  variant="h6">Support & Learning</Typography>
          <Box sx={{display: "flex", flexDirection: "column",}}>
            <Link href="https://www.cadsoft.com/learning-center/classes/" sx={footerLink}>Events & Training</Link>
            <Link href="https://www.cadsoft.com/community-posts/" sx={footerLink}>Community</Link>
            <Link href="https://www.cadsoft.com/learning-center/new-to-envisioneer/" sx={footerLink}>New to Envisioneer</Link>
            <Link href="https://www.cadsoft.com/learning-center/support-learning/" sx={footerLink}>Videos & Articles</Link>
            <Link href="https://www.cadsoft.com/products/system-requirements/" sx={footerLink}>System Requirements</Link>
            <Link href="https://www.cadsoft.com/products/gallery/" sx={footerLink}>Image Gallery</Link>
            <Link href="https://www.cadsoft.com/bim-catalogs/" sx={footerLink}>BIM Catalog</Link>
            <Link href="https://www.cadsoft.com/showroom/" sx={footerLink}>Showroom</Link>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography fontSize={16} fontWeight={600} textTransform="uppercase" sx={{mb:2,}} variant="h6">About Us</Typography>
          <Box sx={{display: "flex", flexDirection: "column",}}>
            <Link href="https://www.cadsoft.com/about-us/#who" sx={footerLink}>Who We Are</Link>
            <Link href="https://www.cadsoft.com/about-us/#what" sx={footerLink}>What We Do</Link>
            <Link href="https://www.cadsoft.com/about-us/#why" sx={footerLink}>Why We Do It</Link>
            <Link href="https://www.cadsoft.com/about-us/#how" sx={footerLink}>How It's Done</Link>
            <Link href="https://www.cadsoft.com/about-us/#partners" sx={footerLink}>Our Partners</Link>
            <Link href="https://www.cadsoft.com/our-services/" sx={footerLink}>Our Services</Link>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography fontSize={16} fontWeight={600} textTransform="uppercase" sx={{mb:2,}} variant="h6">Connect with Us</Typography>
            <Box sx={{display: "flex", flexDirection: "column",}}>
              <Link href="https://www.cadsoft.com/book-a-demo/" sx={footerLink}>Book a Demo</Link>
              <Box sx={{display: "flex",}}>
                <Typography sx={{mr:1,}}>Phone:</Typography>
                <Link href="tel:18882237638" sx={footerLink}>+1 (888) 223-7638</Link>
              </Box>
              <Box sx={{display: "flex",}}>
                <Typography sx={{mr:1,}}>Message: </Typography>
                <Link href="https://www.cadsoft.com/sales/" sx={footerLink}>Sales</Link>
                <Typography sx={{mx:1,}}>|</Typography>
                <Link href="https://www.cadsoft.com/support/" sx={footerLink}>Support</Link>
              </Box>
              <Box sx={{display: "flex",}}>
                <Typography sx={{mr:1,}}>Other Sites: </Typography>
                <Link href="https://www.constructionindustrysoftware.com.au/" sx={footerLink}>AUS</Link>
                <Typography sx={{mx:1,}}>|</Typography>
                <Link href="https://www.a-doc.com/" sx={footerLink}>FRA</Link>
                <Typography sx={{mx:1,}}>|</Typography>
                <Link href="https://envisioneer.cn/" sx={footerLink}>CHN</Link>
              </Box>
              <Divider sx={{my: 2,}} />
              <Box sx={{display: "flex", justifyContent:"space-evenly"}}>
                <IconButton href="https://www.cadsoft.com/">
                  <Home />
                </IconButton>
                <IconButton href="https://www.facebook.com/CadsoftCorporation" target="_blank">
                  <Facebook />
                </IconButton>
                <IconButton href="https://www.instagram.com/cadsoft_corp/" target="_blank">
                  <Instagram />
                </IconButton>
                <IconButton href="https://www.youtube.com/user/Cadsoftcorp" target="_blank">
                  <YouTube />
                </IconButton>
                <IconButton href="https://www.linkedin.com/company/cadsoft-corporation" target="_blank">
                  <LinkedIn />
                </IconButton>
              </Box>
            </Box>
        </Grid>
      </Grid>
      <Box sx={{alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center",}}>
        <Box sx={{mt: 5, borderColor: "transparent", borderWidth: 1, "&:hover": { borderColor: "#000000", }, }}>
          <CadsoftLogo height={45} width={150} />
        </Box>
        <Typography fontSize={10} sx={{my: 1,}}>Cadsoft Corporation © {currentYear}, All Rights Reserved.</Typography>
      </Box>
    </Container>
  );
};

export default Footer;
